import { UBCMessageName } from '@epicuro-next/state/ubc-communication/core';
import {
  updateBasketError,
  updateBasketSuccess,
} from '@epicuro-next/state/ubc-communication/ubc-basket';
import { createReducer, on } from '@ngrx/store';

import { shopTheCommercialList } from './ubc-commercial-list.actions';
export interface UbcCommercialListState {
  updatingBasket?: boolean;
}

export const ubcCommercialListReducer = createReducer<UbcCommercialListState>(
  {},
  on(shopTheCommercialList, (state) => ({
    ...state,
    updatingBasket: true,
  })),
  on(updateBasketSuccess, updateBasketError, (state, action) => {
    if (action.payload.source !== UBCMessageName.ShopTheCommercialList) {
      return state;
    }
    return {
      ...state,
      updatingBasket: false,
    };
  }),
);
